import { PhasrTopRecommendationsWebComponent } from './component/PhasrTopRecommendationsWebComponent';

export { PhasrTopRecommendationsWebComponent };
